// Anon-safe column allow-list for public `talent_profiles` reads.
//
// SECURITY (incident 2026-07-09): the `anon` role could read every talent's
// onboarding token (account-takeover vector), earnings and payment/identity
// identifiers via `select('*')`. Those columns are now REVOKED from `anon` at
// the Postgres privilege level, so any anon `select('*')` on talent_profiles
// returns 403 (42501). Public / logged-out pages MUST select this explicit
// allow-list instead.
//
// This is a mirror of the main app allow-list at
// `src/constants/talentColumns.ts` (ShoutOutUS/frontend). Keep it in sync.
//
// Authenticated flows (creator dashboard, onboarding, payouts) run as the
// `authenticated` role, which retains full column access and is unaffected —
// so those reads may continue to use `select('*')`.
//
// Columns intentionally EXCLUDED (never expose to anon):
//   onboarding_token, onboarding_expires_at, instagram_access_token,
//   instagram_token_expires_at, instagram_user_id, moov_account_id,
//   fortis_vendor_id, total_earnings, course_payout_cents,
//   payout_onboarding_step, payout_onboarding_completed, bank_account_linked,
//   veriff_verified_at, chat_banned_at, chat_ban_reason
export const PUBLIC_TALENT_COLUMNS = [
  'id', 'user_id', 'category', 'bio', 'pricing', 'fulfillment_time_hours',
  'charity_percentage', 'charity_name', 'is_featured', 'admin_fee_percentage',
  'total_orders', 'fulfilled_orders', 'average_rating', 'is_active',
  'created_at', 'updated_at', 'corporate_pricing', 'categories', 'username',
  'onboarding_completed', 'social_accounts', 'temp_full_name', 'temp_avatar_url',
  'position', 'allow_corporate_pricing', 'is_verified', 'promo_video_url',
  'is_participating_in_promotion', 'promotion_claimed_at', 'instagram_username',
  'featured_order', 'first_orders_promo_active', 'full_name', 'is_coming_soon',
  'display_order', 'featured_image_position', 'slug', 'keywords',
  'current_onboarding_step', 'demo_order_created', 'instagram_handle',
  'tiktok_handle', 'facebook_handle', 'twitter_handle', 'current_month_orders',
  'last_order_reset_date', 'base_pricing', 'current_pricing_tier',
  'veriff_verified', 'rumble_handle', 'rumble_type', 'youtube_handle',
  'christmas_deadline', 'podcast_rss_url', 'podcast_name', 'follower_counts',
  'promote_on_launch', 'snapchat_handle', 'featured_shoutout_types',
  'display_title', 'express_delivery_enabled', 'express_delivery_price',
  'podcast_platform_links', 'bio_enabled', 'rumble_title_filter',
  'selected_shoutout_types', 'skip_rumble_auto_update', 'rumble_exclude_filter',
  'launch_card_enabled', 'referred_by_partner_id', 'shoutout_fans_status',
  'partner_noted_followers', 'show_on_home_page', 'pricing_mode',
  'audio_shoutout_enabled', 'audio_shoutout_price', 'support_enabled',
  'fan_shoutouts_enabled', 'auto_apply_sponsors', 'auto_sponsor_phase',
  'skip_promo_video', 'collabs_enabled', 'is_exclusive', 'checklist_dismissed',
  'course_completed', 'max_sponsor_ads', 'ad_override', 'bio_proofs_approved',
  'signup_source', 'targeting_category',
].join(',');
